"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'settings.credit.description': 'Configura i tassi di conversione dei crediti per i servizi AI',
    'settings.credit.failedToLoad': 'Impossibile caricare le impostazioni dei crediti',
    'settings.credit.savedSuccessfully': 'Impostazioni crediti salvate con successo',
    'settings.credit.failedToSave': 'Impossibile salvare le impostazioni dei crediti',
    'settings.credit.save': 'Salva Impostazioni Crediti',
    'settings.credit.reload': 'Ricarica',
    'settings.credit.credits': 'crediti',
    'settings.credit.conversion.title': 'Conversione Valuta',
    'settings.credit.conversion.dollarToCreditRate': 'Crediti per USD',
    'settings.credit.conversion.dollarToCreditRate.help': 'Quanti crediti equivalgono a 1 USD. Questo influisce sui prezzi di tutte le operazioni AI.',
    'settings.credit.preview.title': 'Anteprima Conversione',
    'settings.credit.warning.title': 'Avviso Importante',
    'settings.credit.warning.description': 'Le modifiche ai tassi di credito influenzeranno tutte le future operazioni AI. I crediti esistenti degli utenti non saranno influenzati.',
};
